import axios from 'axios';
import { mapState } from 'vuex';

const props = {
};

const computed = {
  ...mapState({
    user: state => state.user,
    dashboardFilters: state => state.dashboardFilters,
    updateDashboardFilters: state => state.updateDashboardFilters,
    adminUsers (state) {
      const adminUsers = state.companyAdminsList;
      return adminUsers;
    }
  })
};

const methods = {
  getStages () {
    this.table.loading = true;
    const filters = Object.assign({}, this.updateDashboardFilters);
    if (filters && filters.filters) {
      // filters.filters have the dynamic filters value
      delete filters.filters;
    }
    const queryParams = {
      page_offset: this.page_offset,
      page_limit: this.pageLimit,
      ...filters
    };
    if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
      this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
        if (v.length > 0) {
          queryParams[`user__profile__${k}__in`] = v.join();
        }
      });
    }
    this.npsBreakdown = [];
    axios.get(`${process.env.VUE_APP_API_URL}stage/list?fields=id,title,status,stageIndex,createdAt,engagement_score,overall_mood,chat_response_stats,stage_response_breakdown`, {
      params: queryParams
    }).then((response) => {
      if (response && response.data) {
        const temp = response.data.data;
        this.$lodash.each(temp, (milestone, index) => {
          milestone.milestoneIndex = index;
        });
        this.table.stage = temp;
        this.table.totalItems = response.data.total_count;
        setTimeout(() => {
          this.sortStageData();
        }, 50);
        setTimeout(() => {
          this.table.loading = false;
        }, 500);
      }
    }).catch((err) => {
      if (err.response.status === 429) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: err.response.data.error
        });
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to fetch touchpoints report, Please try again later!'
        });
      }
    });
  }
};

export default {
  props,
  computed,
  methods
};
